import {Component, OnInit, Inject, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {DateAdapter} from '@angular/material/core';
import {MatTableDataSource} from '@angular/material/table';
import {ErrorStateMatcher} from '@angular/material/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {SnackBarIconService} from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {ActivityService} from 'src/app/services/activity.service';
import {Activity} from 'src/app/models/event';
import {EventTopicDialogComponent} from '../event-topic-dialog/event-topic-dialog.component';
import {TopicService} from 'src/app/services/topic.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {DayService} from 'src/app/services/day.service';
import {AgendaService} from 'src/app/services/agenda.service';
import {EventStaffDialogComponent} from '../event-staff-dialog/event-staff-dialog.component';
import {finalize} from 'rxjs/operators';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';
import {BannerDialogComponent} from '../banner-dialog/banner-dialog.component';
import {PreviewService} from 'src/app/services/preview.service';
import {DomSanitizer} from '@angular/platform-browser';
import {DepartmentService} from 'src/app/services/department.service';
import {ConventionCenterService} from 'src/app/services/convention-center.service';
import {AlertComponent} from 'src/app/shared/dialogs/alert/alert.component';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-event-activity-dialog',
  templateUrl: './event-activity-dialog.component.html',
  styleUrls: [ './event-activity-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent,
    EventTopicDialogComponent,
    EventStaffDialogComponent
  ],
})
export class EventActivityDialogComponent implements OnInit {

  public Editor = ClassicEditor;
  public matcher = new FormErrorStateMatcher();


  public activityForm: FormGroup;

  public displayedColumns: string[] = [ 'icon', 'name', 'date', 'edit', 'delete' ];
  public displayedTeamColumns: string[] = [ 'member_name', 'role_name', 'buttons' ];
  public pdfForm: FormGroup;

  public displayedPdfColumns: string[] = [ 'icon', 'name', 'delete' ];



  public agendaActivityDataSource: MatTableDataSource<any>;
  public sponsorsDataSource: MatTableDataSource<any>

  public displayedSponsorColumns: string[] = [ 'image', 'link', 'delete' ];
  public displayedAgendaColumns: string[] = [ 'member_name', 'role_name', 'button_edit', 'button_delete' ];

  public htmlPreview: any = "";

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor (
    private fs: AngularFireStorage,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    public _dayService: DayService,
    public _activityService: ActivityService,
    public _topicService: TopicService,
    private _adapter: DateAdapter<any>,
    public _agendaService: AgendaService,
    public _previewService: PreviewService,
    public _departmentService: DepartmentService,
    public _conventionCenterService: ConventionCenterService,
    public _sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this._activityService.currentEvent = this.data.event
    this._activityService.currentDay = this.data.day;
    this._activityService.currentActivity = this.data.activity;

    // console.log('activity: ' + JSON.stringify(this._activityService.currentActivity))

    this._conventionCenterService.loadConventionCenters(this._activityService.currentEvent.location_id)
    //
    // console.log("this._activityService.currentEvent.context_id: " + this._activityService.currentEvent.context_id)
    //
    this._departmentService.loadDeptos(this._activityService.currentEvent.context_id);
    // console.log("this._activityService.departments: " + JSON.stringify((this._departmentService.departments)))

  }

  ngOnInit () {
    this._adapter.setLocale('pt');

    this._activityService.setEdit()

    if (!this._activityService.currentActivity) {
      this._activityService.currentActivity = new Activity();
      this._activityService.currentActivity.date = this._activityService.currentDay.date
    }

    this.activityForm = this._activityService.createForm(this._activityService.currentActivity)

    this._agendaService.loadRoles();

    this.pdfForm = this._activityService.createPdfForm();
    this._activityService.setPdfDataSource();

    //load activity agenda

    if (this.data.activity) {
      this.loadAgenda(this.data.activity.id)
    }

    //Load Topics
    if (this._activityService.currentActivity.id) {
      this._topicService.select(this._activityService.currentActivity.id)
    }

    this.loadBannerSponsors();

  }

  ngOnDestroy () {
  }

  applyFilter (filterValue: string) {
    this._topicService.topicDataSource.filter = filterValue.trim().toLowerCase();
  }

  loadAgenda (activity_id) {
    this._agendaService.loadAgendaActivity(activity_id)
      .subscribe((result) => {
        this._agendaService.agendaActivityNotes = result.map(item => {
          return this._agendaService.makeNote(item.payload.doc)
        })

        this._agendaService.agendaActivityNotes.sort(this._agendaService.compareStart)
        this.agendaActivityDataSource = new MatTableDataSource(this._agendaService.agendaActivityNotes);
      })
  }

  insert () {

    this._topicService.topicDataSource = new MatTableDataSource([]);
    //console.log(JSON.stringify(this.activityForm.value))

    if (this.activityForm.valid) {
      this._activityService.insert(this.activityForm.value)
        .then((result: Activity) => {
          this._activityService.currentActivity = result;
          const dpto = this._departmentService.departments.find((e) => {
            return e.id == result.depto_id
          })
          this._activityService.currentActivity.depto = dpto.short
        })
    }


  }

  update () {
    if (this.activityForm.valid) {
      let id = this._activityService.currentActivity.id
      this._activityService.update(id, this.activityForm.value)
    }
  }

  //  TOPIC  /////////////////////////////////////////

  openTopicDialog (topic) {

    console.log('this._activityService.currentActivity.depto_id: ' + this._activityService.currentActivity.depto_id)
    console.log('this._activityService.currentActivity.depto: ' + this._activityService.currentActivity.depto)

    this._agendaService.agendaActivityNotes = []
    this._agendaService.agendaActivityDataSource = new MatTableDataSource(this._agendaService.agendaActivityNotes);

    let data = {
      event: this._activityService.currentEvent,
      day: this._activityService.currentDay,
      activity: this._activityService.currentActivity,
      topic: topic
    }


    const w = window.innerWidth - 460;
    const h = window.innerHeight - 140;

    let dialogRef = this.dialog.open(EventTopicDialogComponent, {
      //width: '890px',
      //height: '550px',
      width: w.toString() + "px",
      height: h.toString() + "px",
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {

      //   console.log("fechou!!")
      // let tempData = this._topicService.topicDataSource.data;
      //  this._topicService.topicDataSource.data = tempData
      this._topicService.select(this._activityService.currentActivity.id)

    })

  }

  deleteTopic (element) {
    this._topicService.delete(element)
  }


  ////////////////////////////////////////////////////////
  // STAFF DIALOG

  openStaffDialog (entity) {

    let data: any = {};

    if (entity) {
      data = entity;
    }

    let dialogRef = this.dialog.open(EventStaffDialogComponent, {
      width: '600px',
      height: '350px',
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        const actionType: string = response[ 0 ];
        const formData: FormGroup = response[ 1 ];
        const rawData = formData.getRawValue();
        const entity = this.makeNotesInAgenda(rawData);
        // console.log("entity >> : " + JSON.stringify(entity))

        switch (actionType) {
          case 'insert':
            this._agendaService.insert(entity)
            break;
          case 'update':
            this._agendaService.update(entity)
            break;
        }

        this.loadAgenda(this._activityService.currentActivity.id)

      });
  }


  makeNotesInAgenda (rawData: any) {
    const depto = this._departmentService.departments.find((e) => {
      return e.id == this._activityService.currentActivity.depto_id
    })
    this._activityService.currentActivity.depto = depto.short

    const role = this._agendaService.roles.find((e) => {
      return e.id == rawData.role_id
    })

    const data = {
      'id': rawData.id,
      "member_id": rawData.member.id,
      "member_name": rawData.member.name,
      "member_state": rawData.member.state,
      "member_country": rawData.member.country,
      "role_id": rawData.role_id,
      "role_name": role.name,
      "requireConfirm": rawData.requireConfirm,
      "requireSchedule": rawData.requireSchedule
    }

    const note = this._agendaService.createAgenda(
      "a",
      data,
      this._activityService.currentEvent,
      this._activityService.currentDay,
      this._activityService.currentActivity,
      null)

    return note;
  }


  loadBannerSponsors () {
    if (this._activityService.currentActivity.sponsors && this._activityService.currentActivity.sponsors.length > 0) {

      //console.log('this._activityService.currentActivity.sponsors ' + JSON.stringify(this._activityService.currentActivity.sponsors))

      this.sponsorsDataSource = new MatTableDataSource(this._activityService.currentActivity.sponsors)
    }
  }

  updateBannerSponsor (banner) {

    if (!this._activityService.currentActivity.sponsors) {
      this._activityService.currentActivity.sponsors = []
    }

    this._activityService.currentActivity.sponsors.push(banner)
    this.sponsorsDataSource = new MatTableDataSource(this._activityService.currentActivity.sponsors)

    console.log("banner: " + JSON.stringify(banner))

    this._activityService.updateBannerSponsor(this._activityService.currentActivity.id, this._activityService.currentActivity.sponsors)

  }

  removeBannerSponsor (element) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.link + "<br><br>Excluir este banner?"}
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result == "ok") {
        this._activityService.currentActivity.sponsors = this._activityService.currentActivity.sponsors.filter((e) => {
          return e.id != element.id;
        })

        this.sponsorsDataSource = new MatTableDataSource(this._activityService.currentActivity.sponsors)
        //  console.log("this._eventService.currentEvent.sponsors: " + JSON.stringify(this._eventService.currentEvent.sponsors))
        this._activityService.updateBannerSponsor(this._activityService.currentActivity.id, this._activityService.currentActivity.sponsors)
          .then(() => {

            const fsRef: any = this.fs.storage.refFromURL(element.image);
            fsRef.delete();

          })

      }
      else {
        return result
      }

    })


  }

  openBannerDialog (element) {

    let dialogRef = this.dialog.open(BannerDialogComponent, {
      width: '600px',
      height: '470px',
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: {'isProduct': false}
    })

    dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }

        const bannerForm: FormGroup = response[ 0 ];
        const objectBanner: any = response[ 1 ];

        const formData = bannerForm.getRawValue();

        let banner: any = {};

        banner.id = new Date().getTime();
        banner.link = formData.link || '';

        const fsRef: AngularFireStorageReference = this.fs.ref("images/banner_sponsors/" + "banner_" + banner.id + ".png");
        const fsTask: AngularFireUploadTask = fsRef.put(objectBanner);

        fsTask.snapshotChanges().pipe(
          finalize(() => {
            fsRef.getDownloadURL().subscribe(url => {
              banner.image = url;
              this.updateBannerSponsor(banner);
            });
          }))
          .subscribe();
      })
  }


  refreshPreview () {
    console.log("refresh preview")

    this._previewService.selectTopicByActivity(this._activityService.currentActivity.id)
      .then((results: any) => {

        // console.log("results: " + JSON.stringify(results))

        let html = '<div>'

        results[ 0 ].forEach(topic => {

          html += "<div>" + topic.name + "</div>"
          html += "<div style='margin-left: 20px;'>Início: " + topic.startTime + "</div>"
          html += "<div style='margin-left: 20px;'>Duração: " + topic.duration + "</div>"

          const agenda_topic = results[ 1 ].filter((e) => {
            return e.topic_id == topic.id
          })

          // console.log("agenda: " + JSON.stringify(agenda_topic))
          agenda_topic.forEach((ag: any) => {
            html += "<div style='margin-left: 30px;'>" + ag.role_name + " - " + ag.member_name + "</div>"
          })

          html += '<br>'
        });

        html += '</div>'

        this.htmlPreview = this._sanitizer.bypassSecurityTrustHtml(html)

      })
      .catch((err) => {
        console.log("erro")
      })
  }

  selecteDepartent (event) {
    //console.log('change to depto: ' + event)
    const activity_id = this._activityService.currentActivity.id;
    const depto_id = this._activityService.currentActivity.depto_id

    //console.log('activity_id: ' + activity_id)
    //console.log('depto_id: ' + depto_id)

    if (activity_id && depto_id) {
      if (event !== depto_id) {

        this._agendaService.getAgendaByActivityAndDepto(activity_id, depto_id)
          .subscribe((result) => {

            console.log('esta vazio? ' + !result.empty)

            if (!result.empty) {
              let dialogRef = this.dialog.open(AlertComponent, {
                width: '350px',
                height: '270px',
                panelClass: 'custom-dialog-container',
                data: {title: "Alerta", message: "O Departamento não pode ser alterado para esta Atividade<br><br>Remova a equipe antes de alterar."}
              });
              dialogRef.afterClosed().subscribe(result => {
                console.log("FECHOU")
                this.activityForm.controls.depto_id.setValue(depto_id)
              })
            }
          })
      }
    }

  }

  selecteRoom (event) {
    //console.log('room: ' + event)

  }
}